<div class="row">
  <div class="counter">{{aggregatedJobData.totalDirect}}</div>
  <div class="content">
    <div class="aggregatedJobData">
      <span class="color-indicator"></span>
      <span class="align-middle phase-text-styling">In review</span>
      <span
        class="align-middle phase-text-styling font-weight-bold desktop">{{aggregatedJobData.inReviewDirect}}</span>
    </div>
    <div class="aggregatedJobData">
      <span class="color-indicator shortlisted"></span>
      <span class="align-middle phase-text-styling">Shortlisted</span>
      <span
        class="align-middle phase-text-styling font-weight-bold desktop">{{aggregatedJobData.shortlisted}}</span>
    </div>
    <div class="aggregatedJobData">
      <span class="color-indicator rejected"></span>
      <span class="align-middle phase-text-styling">Rejected</span>
      <span
        class="align-middle phase-text-styling font-weight-bold desktop">{{aggregatedJobData.rejected}}</span>
    </div>
  </div>
  <div class="content mobile">
    <div>
      <span
        class="align-middle phase-text-styling number-style">{{aggregatedJobData.inReviewDirect}}</span>
    </div>
    <div>
      <span
        class="align-middle phase-text-styling number-style">{{aggregatedJobData.shortlisted}}</span>
    </div>
    <div>
      <span
        class="align-middle phase-text-styling number-style">{{aggregatedJobData.rejected}}</span>
    </div>
  </div>
</div>
